import React from 'react';
import { FiCode } from 'react-icons/fi';
import AddTalentPage from '../talents/AddTalentPage';

const AddProgrammer = () => (
  <AddTalentPage
    category="programmer"
    icon={<FiCode />}
    titleKey="website.add_programmer.title"
    subKey="website.add_programmer.sub"
    listPath="/programmers"
  />
);

export default AddProgrammer;
